import type { Page as PageType } from 'src/types/page';
import { AboutPage } from 'src/sections/about/about-page';

const Page: PageType = () => <AboutPage />;

export default Page;
